<template>
  <div class="home-header" :class="{ homeDisable: isEdit }">
    <!-- 按钮 -->
    <div class="head-tab" v-show="!isEdit">
      <div :class="{'selected-tab': $store.state.isHome }" @click="tabFn1">
        首页
      </div>
      <div :class="{'selected-tab': !$store.state.isHome }" @click="tabFn2">
        统计分析
      </div>
    </div>
    <div class="head-tab" v-show="isEdit">
      <div
        @mouseenter="enterFn1"
        @mouseleave="leaveFn"
        @click="confirmFn"
        :class="{ 'selected-tab2': isEnter === 1 }"
      >
        返回
      </div>
      <!-- <div
        @mouseenter="enterFn2"
        @mouseleave="leaveFn"
        @click="cancelFn"
        :class="{ 'selected-tab2': isEnter === 2 }"
      >
        取消
      </div> -->
    </div>
    <div class="head-title" >
      {{title}}
    <el-upload
      class="avatar-uploader"
      :action="`https://www.zhuoke211025.com/api/logoImage/add?uuid=${uuid}`"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-error = "uploadError"
      >
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
    </el-upload>
    </div>
    <!-- 时间 -->
    <div class="head-time">
      <div class="nowDate">{{ nowDate }}</div>
      <div class="nowTime">{{ nowTime }}</div>
      <div
        class="user-button"
        :class="{ disableUser: isEdit }"
        @mouseenter="enterFn"
        @mouseleave="leaveFn"
      >
        <div class="head_tip" v-show="flag"
        >
        <div
          :class="{ tipStyle: tab == 0, tipColor: tabColor == 0 }"
          @click.stop="classFn"
          @mouseenter="tipEnter"
          @mouseleave="tipLeave"
          v-if="userInfo.userAccess == 1"
        >
          数据编辑
        </div>
        <div
          :class="{ tipStyle: tab == 1, tipColor: tabColor == 1 }"
          @click.stop="classFn2"
          @mouseenter="tipEnter2"
          @mouseleave="tipLeave"
          v-if="userInfo.userAccess == 1"
        >
          用户管理
        </div>
         <div
          :class="{ tipStyle: tab == 2, tipColor: tabColor == 2 }"
          @click="userFn"
          @mouseenter="tipEnter3"
          @mouseleave="tipLeave"
          v-if="userInfo.userAccess == 1"
        >
          数据可视化编辑
        </div>
        <div
          class="log_out"
          :class="{ outColor: outEnter }"
          @click="logOutFn"
          @mouseenter="outEnterFn"
          @mouseleave="outLeaveFn"
        >
          退出
        </div>
      </div>
      </div>
      <div class="userName">{{userInfo.userName}}</div>
    </div>
  </div>
</template>
<script>
import {getAvatar} from "@/assets/api/feedingStyle";
export default {
  props: ["isHomeEdit","userInfo","title"],
  data() {
    return {
      nowDate: null, //存放年月日变量
      nowTime: null, //存放时分秒变量
      timer: "", //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
      isEdit: false, // 是否编辑模式
      isEnter: 0,
      flag: false, //个人中新的打开编辑页面
      tab: -1,
      tabColor: -1,
      outEnter: false,
      headTip: false,
      // 用户列表
      userList: [],
      titleTop:"实验室锂电池生产线数字孪生系统",
      imageUrl:"http://zhuoke211025.com/LogoImg/logo.png",
      uuid:"",//用户id
    };
  },
  // 实例创建前调用
  created() {
    this.timer = setInterval(this.getCurrentTime, 1000);
  },
  mounted() {
    this.titleTop = this.title;
    this.$nextTick(()=>{
      this.uuid = this.userInfo.uuid;
      this.getAvatars();
    });
    //查询用户的头像
    // this.getAvatars();
  },
  methods: {
    // 获取当前日期时间
    getCurrentTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      if (this.hour > 12) {
        this.hour -= 12;
      }
      this.month = check(month);
      this.day = check(day);
      this.hour = check(hour);
      this.minute = check(minute);
      this.second = check(second);
      function check(i) {
        const num = i < 10 ? "0" + i : i;
        return num;
      }
      this.nowDate = year + "年" + this.month + "月" + this.day + "日";
      this.nowTime = this.hour + ":" + this.minute + ":" + this.second;
    },
    //点击tab
    tabFn1() {
      this.$store.commit("flagUpdate",3);
      this.$store.commit("homeTab", true);
      this.$emit("headTabFn", false);
      this.$store.commit("incrementFive",0);
       this.$emit('getchartData');
    },
    tabFn2() {
      this.$store.commit("homeTab", false);
      this.$emit("headTabFn", true);      
    },
    // 移入事件
    enterFn1() {
      this.isEnter = 1;
    },
    enterFn2() {
      this.isEnter = 2;
    },
    // 移出事件
    leaveFn() {
      this.isEnter = 0;
    },
    // 确认修改
    confirmFn() {
      this.isEdit = false;
      this.$emit("head-confirm-edit");
      //console.log("确认修改");
    },
    // 取消修改
    cancelFn() {
      this.$emit("head-cancel-edit");
      console.log("取消修改");
    },
    userFn() {
      this.$emit("userFn");
    },
    //个人中心的鼠标移入事件
    enterFn() {
      this.flag = true;
    },
    //个人中心的鼠标移出事件
    leaveFn() {
      this.flag = false;
    },
    //点击编辑数据
    classFn() {
      this.tab = 0;
      this.$router.push("/compile/home");
      this.$emit('sendValue', '进入编辑')
    },
    tipEnter2() {
      this.tabColor = 1;
    },
    tipEnter3() {
      this.tabColor = 2;
    },
    headTipLeave() {
      this.headTip = false;
      this.tab = -1;
    },
      tipEnter() {
      this.tabColor = 0;
    },
    tipLeave() {
      this.tabColor = -1;
      this.tab = -1;
    },
    //点击管理用户执行的方法
     classFn2() {
      this.tab = 1;
      this.getUserList();
      this.$store.commit("isShowUpdate", true);
    },
     tipEnter2() {
      this.tabColor = 1;
    },
    logOutFn() {
      sessionStorage.clear();
      this.$store.commit("flagUpdate",3);
      this.$store.commit("homeTab", true);
      this.$emit("headTabFn", false);
      this.$store.commit("incrementFive",0);
      this.$emit('getchartData');
      this.$router.replace("/login");
      ClearScene_index();
      ClearScene_Model();
    },
    outEnterFn() {
      this.outEnter = true;
    },
    outLeaveFn() {
      this.outEnter = false;
    },
      // 获取用户列表
    getUserList() {
       //调用index父组件的getUserInfo方法
       this.$parent.getUserInfo();
    },
    handleAvatarSuccess(res, file) {
        this.$message.success("上传成功!");
        this.imageUrl = res.data;
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/png' || file.type === 'image/jpeg'  ;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 png 格式或者jpg!');
        }
        if (!isLt2M) {
          setTimeout(() => {
             this.$message.error('上传头像图片大小不能超过 2MB!');
          }, 1000);
        }
        return isJPG && isLt2M;
    },
    uploadError(err,file,fileList){
      this.$message.error("上传失败!");
    },
     //查询到用户头像
    async getAvatars() {
      let res = await getAvatar(this.uuid);
      this.imageUrl = res.data;
      this.$store.commit("getImgUrl", res.data);
    },
  },
  watch: {
    isHomeEdit(n) {
      this.isEdit = n;
    },
  },
  beforeDestroy() {
    // 在Vue实例销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style lang="less" scoped>
.home-header {
  z-index: 999;
  padding: 60px 30px 0 24px;
  background: url("./image/header-bg.png") no-repeat 0 0;
  background-size: 100% 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: default;

  // 按钮head-time
  .head-tab {
    width: 350px;
    height: 40px;
    // 增加权重
    z-index: 9;
    display: flex;

    div {
      width: 170px;
      height: 40px;
      margin-right: 10px;
      background: url("./image/unselected-bg.png") no-repeat 0 0;
      background-size: 100% 100%;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }

    // 选中
    .selected-tab {
      background: url("./image/selected-bg.png") no-repeat 0 0;
      background-size: 100% 100%;
      pointer-events: none;
    }
    // 没有pointer-events属性
    .selected-tab2 {
      background: url("./image/selected-bg.png") no-repeat 0 0;
      background-size: 100% 100%;
    }
  }

  // title
  .head-title {
    width: 100%;
    height: 80px;
    font-size: 46px;
    font-family: TitleFamily;
    text-align: center;
    line-height: 80px;
    color: #ffffff;
    letter-spacing: 1px;
    /* 文字不可选取 */
    user-select: none;
    position: fixed;
    top: 0;
    left: 0;

    img{
      position:absolute;
      top: 5px;
      left: 70px;
      width: 116px;
    }
  }

  // 时间
  .head-time {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    // 增加权重
    z-index: 9;

    .nowDate {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      white-space: nowrap;
    }

    .nowTime {
      height: 25px;
      padding: 0 12px;
      margin-left: 20px;
      font-size: 24px;
      font-weight: 500;
      line-height: 25px;
      color: #ffffff;
      border-left: 2px solid #ffce00;
      white-space: nowrap;
    }

    .userName{
      margin-left: 10px;
      // background-color: pink;
      font-size: 18px;
      font-weight: 800;
      font-family: Gothic;
      color: #24d8ff;
    }

    .user-button {
      width: 37px;
      height: 37px;
      padding-top: 40px;
      background: url("./image/user-icon.png") no-repeat 0 0;
      background-size: 100% 100%;
      cursor: pointer;
    }

    .disableUser {
      background: url("./image/user-disabled-icon.png") no-repeat 0 0;
      background-size: 100% 100%;
    }
  }
}

.homeDisable {
  background: url("./image/header-disabled-bg.png") no-repeat 0 0;
  background-size: 100% 80px;
}

.compile {
  position: absolute;
  top: 100px;
  right: 32px;
  color: #fff;
}
  .head_tip {
    background: linear-gradient(
      90deg,
      rgba(16, 176, 255, 0.2) 0%,
      rgba(0, 8, 11, 0.3) 100%
    );
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    position:absolute;
    right: 50px;

    div {
      width: 132px;
      height: 36px;
      font-size: 14px;
      padding-left: 16px;
      margin: 4px 10px;
      line-height: 36px;
      font-family: Gothic;
      color: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0);
      cursor: pointer;
    }

    .tipColor {
      border: 1px solid #24d8ff;
    }

    .tipStyle {
      background: rgba(4, 18, 25, 0.85)
        linear-gradient(
          90deg,
          rgba(16, 176, 255, 0.45) 0%,
          rgba(16, 176, 255, 0.25) 100%
        );
      border: 1px solid #24d8ff;
      font-size: 14px;
      font-family: Gothic;
      color: #ffffff;
    }
    .log_out {
      // 清除padding
      padding: 0;
      margin-top: 10px;
      border: 0;
      background: linear-gradient(
        270deg,
        rgba(16, 176, 255, 0.25) 0%,
        rgba(36, 216, 255, 0.85) 100%
      );
      font-size: 14px;
      text-align: center;
      line-height: 36px;
      font-family: Gothic;
      color: #ffffff;
    }
    .outColor {
      color: #24d8ff;
      background: linear-gradient(
        90deg,
        rgba(16, 176, 255, 0.85) 0%,
        rgba(36, 216, 255, 0.25) 100%
      );
    }
  }
    

</style>